import { render, staticRenderFns } from "./image_guide_6.vue?vue&type=template&id=19fd68f1&scoped=true"
import script from "./image_guide_6.vue?vue&type=script&lang=js"
export * from "./image_guide_6.vue?vue&type=script&lang=js"
import style0 from "./image_guide_6.vue?vue&type=style&index=0&id=19fd68f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fd68f1",
  null
  
)

export default component.exports